import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
export function Final() {
  return <section className="py-20 md:py-32 px-4 bg-brand-dark border-t border-white/5 text-center" data-id="element-72">
      <div className="max-w-5xl mx-auto" data-id="element-73">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-[2.25rem] sm:text-5xl md:text-7xl lg:text-8xl text-white mb-8 leading-[0.95] break-words" data-id="element-74">
          CADA SEMANA QUE PASA, ALGUIEN MÁS{' '}
          <span className="text-brand-yellow" data-id="element-75">
            COBRA POR ESTE TIPO DE TRABAJOS.
          </span>
        </motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.1
      }} className="text-xl md:text-3xl text-gray-300 font-medium mb-10 md:mb-12" data-id="element-76">
          La pregunta es si vos vas a seguir mirando o vas a empezar.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} data-id="element-77">
          <Button className="py-6 px-12 text-2xl md:text-3xl" data-id="element-78">
            QUIERO ACCESO AHORA
          </Button>
        </motion.div>
      </div>
    </section>;
}